import { IRootState } from '../../../store'
import { IPatientMedications } from '../store/patientMedications.types'

export const getPatientMedicationsListSelector = (state: IRootState): IPatientMedications =>
  state.patientMedications.patientMedicationsList
